export default {
  path: 'places',
  name: 'places',
  redirect: { name: 'places.listing' },
  component: () =>
    import(/* webpackChunkName: "places" */ '@/views/Home/Places'),
  children: [
    {
      path: '/',
      name: 'places.listing',
      component: () =>
        import(/* webpackChunkName: "places" */ '@/views/Home/Places/PlaceList')
    },
    {
      path: 'create',
      name: 'places.create',
      component: () =>
        import(
          /* webpackChunkName: "places" */ '@/views/Home/Places/CreatePlace'
        )
    },
    {
      path: 'update/:id',
      name: 'places.update',
      component: () =>
        import(
          /* webpackChunkName: "places" */ '@/views/Home/Places/UpdatePlace'
        )
    }
  ]
}
